import ArrayHelper from "../../lib/array-helper";

export default class DOMElement {
    constructor(tag, props = {}) {
        this.tag = tag;
        this.props = props;
        this._element = null;
        this._init();
    }

    _init() {
        this._beforeInit();
        this._setProps();
        this._checkProps();
        this._initProps();
        this._create();
        this._render();
    }

    _beforeInit() {}

    _setProps() {
        this.class = this.props.class;
        this.attributes = this.props.attributes || {};
        this.text = this.props.text;
        this.html = this.props.html;
        this.children = this.props.children || [];
        this.child = this.props.child;
        this.eventListeners = this.props.eventListeners || [];
        this.parent = this.props.parent;
    }

    _checkProps() {
        if (this.tag == null) {
            throw new Error('DOMElement: Tag is not defined.');
        }

        if (this.tag === 'template' && !this.html) {
            throw new Error('DOMElement: Template tag should have HTML property.');
        }

        if (!this.attributes || typeof this.attributes !== 'object') {
            throw new Error('DOMElement: Attributes should be an object.');
        }

        if (!Array.isArray(this.eventListeners)) {
            throw new Error('DOMElement: Event listeners should be an array.');
        }

        this.eventListeners.forEach((eventListener) => {
            if (typeof eventListener !== 'object') {
                throw new Error('DOMElement: Event listener should be an object.');
            }

            if (!eventListener.event || !eventListener.listener) {
                throw new Error('DOMElement: Event listener should have event and listener properties.');
            }
        });

        if (!Array.isArray(this.children)) {
            throw new Error('DOMElement: Children should be an array.');
        }

        this.children.forEach((child) => {
            if (!(child instanceof DOMElement)) {
                throw new Error('DOMElement: Children should be an array of DOMElement instances.');
            }
        });

        if (this.child && !(this.child instanceof DOMElement)) {
            throw new Error('DOMElement: Child should be an instance of DOMElement.');
        }
    }

    _initProps() {}

    _create() {
        if (this.tag === 'template') {
            this._element = document.createElement('div');
            this._element.innerHTML = this.html;
            this._element = this._element.firstElementChild;
        } else {
            this._element = document.createElement(this.tag);
        }

        const className = DOMElement.classListFrom(this.attributes.class, this.class).join(' ');

        if (className) {
            this._element.setAttribute('class', className);
        }

        Object.keys(this.attributes).forEach((key) => {
            if (key !== 'class') {
                this._element.setAttribute(key, this.attributes[key]);
            }
        });

        if (this.tag !== 'template') {
            if (this.children.length) {
                this.children.forEach((child) => {
                    this._element.appendChild(child.getElement());
                });
            } else if (this.child) {
                this._element.appendChild(this.child.getElement());
            } else if (this.html != null) {
                this._element.innerHTML = this.html;
            } else if (this.text != null) {
                this._element.textContent = this.text;
            }
        }
    }

    _render() {
        if (this.parent) {
            this.parent.replaceChildren(this._element);
        }
    }

    getElement() {
        return this._element;
    }

    static classListFrom(...classLists) {
        let classList = [];

        classLists.forEach((list) => {
            if (list && Array.isArray(list) && list.length) {
                classList = classList.concat(list);
            } else if (list && typeof list === 'string') {
                classList = classList.concat(list.split(' '));
            }
        });

        return ArrayHelper.unique(classList);
    }
}